
import { Component, Vue } from 'vue-property-decorator'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import UpdateDialog from './updateDialog.vue'
import ConfigLogDialog from '../configLog.vue'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'tutorConfig',
  components: {
    UpdateDialog,
    ConfigLogDialog
  }
})
export default class extends Vue {
  private tableData = [] // 团队数据
  private columns = [
    { field: 'id', title: 'ID' },
    { field: 'current_date', title: '日期' },
    { field: 'is_workday_info', title: '属性' }
  ]

  private updateType = 'add' // 新建/编辑类型 add-新建，edit-编辑
  private currentNode = {} // 当前选择的节点
  private total = 0 // 总条数
  private currentPage = 1
  private pageSize = 30

  private getTagType(isWorkday: string): string {
    return isWorkday === '节假日' ? 'success' : 'danger' // 节假日显示绿色，否则红色
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  mounted() {
    this.getTableData()
  }

  // 获取团队数据
  private async getTableData() {
    await CONFIGAPI.getWorkDayList({
      page: this.currentPage,
      page_size: this.pageSize,
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.total = res.data.count
        this.tableData = res.data.lists
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 查看操作日志
  handleShowLog() {
    ConfigModule.ToggleDialogStatus({
      name: 'configLogDialog',
      value: true
    })
  }

  // 新增
  private handleCreate() {
    this.updateType = 'add'
    ConfigModule.ToggleDialogStatus({
      name: 'workdayAddDialog',
      value: true
    })
  }

  // 编辑
  private handleEdit(data: any) {
    this.updateType = 'edit'
    this.currentNode = data
    ConfigModule.ToggleDialogStatus({
      name: 'workdayAddDialog',
      value: true
    })
  }

  // 删除
  private handleDelete(data: any) {
    this.$confirm(`确定要删除当前团队么？【${data.name}】`)
      .then(_ => {
        CONFIGAPI.delTeamInfo({
          id: data.id
        }, {
          app_id: this.userCurrentApp
        }).then((res) => {
          if (res.stat === 1) {
            this.$message.success(res.data)
            this.getTableData()
          }
        }).catch((error) => {
          console.log('发生错误！', error)
        })
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(_ => {})
  }

  // 子组件接口调用成功后
  private handleSuccess() {
    this.getTableData()
  }

  private handleSizeChange(val: number) {
    this.currentPage = 1
    this.pageSize = val
    this.getTableData()
  }

  private handleCurrentChange(val: number) {
    this.currentPage = val
    this.getTableData()
  }
}
